// import React from 'react';
import PropTypes from 'prop-types';
// import { Link } from 'react-router-dom';

const HeroHeader = ({ title, breadcrumbs }) => {
  return (
    <div className="container-fluid hero-header">
      <div className="container">
        <div className="row">
          {/* <div className="col-lg-7">
            <div className="hero-header-inner animated zoomIn">
              <h1 className="display-1 text-dark">{title}</h1>
              <ol className="breadcrumb mb-0">
                {breadcrumbs.map((breadcrumb, index) => (
                  <li key={index} className={`breadcrumb-item ${breadcrumb.isCurrentPage ? 'text-dark' : ''}`} aria-current={breadcrumb.isCurrentPage ? 'page' : undefined}>
                    {breadcrumb.isCurrentPage ? (
                      breadcrumb.label
                    ) : (
                      <Link href={breadcrumb.href}>{breadcrumb.label}</Link>
                    )}
                  </li>
                ))}
              </ol>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

HeroHeader.propTypes = {
  title: PropTypes.string.isRequired,
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      href: PropTypes.string.isRequired,
      isCurrentPage: PropTypes.bool.isRequired,
    })
  ).isRequired,
};

export default HeroHeader;
